var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-page"},[_c('div',{staticClass:"finance-section"},[_c('ulu-finance-revenue')],1),_c('div',{staticClass:"finance-section"},[_c('ulu-finance-kpi')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }